import { useAppSelector } from "store/store";

export const useTop = (imageId: string) => {
    const top = useAppSelector((store) => store.bulkResize.images.find((image) => image.id === imageId)?.crop.top) || 0;

    return { top };
};
